import ConfirmationModal from "Components/Atoms/ConfirmationModal";
import { useEffect, useState } from "react";

type Props = {
  isOpen: boolean;
  defaultValue?: string;
  onContinue: (email: string) => void;
  onCancel: () => void;
};

function EmailModal({ isOpen, defaultValue, onContinue, onCancel }: Props) {
  const [email, setEmail] = useState(defaultValue || "");
  useEffect(() => {
    setEmail(defaultValue || "");
  }, [defaultValue]);
  return (
    <ConfirmationModal
      isOpen={isOpen}
      content={
        <div className="flex flex-col gap-2">
          <label className="text-center">
            Please type the email address where you want to send the Final
            Report:
          </label>
          <input
            type="text"
            id="email"
            name="email"
            value={email}
            className="w-full rounded-md border border-black px-4 py-2 text-black"
            onChange={({ target: { value } }) => setEmail(value)}
          />
        </div>
      }
      canContinue={email !== ""}
      onContinue={() => onContinue(email)}
      onCancel={onCancel}
    />
  );
}

export default EmailModal;
